module.exports = " <div class=\"row gris-lighter\"> <div ui-view=principal@></div> <div ui-view=indicators@></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/teaching/studentAttention/consultCalendar/index.html
// module id = 583
// module chunks = 0